import { useEffect, useRef } from 'react';
import ModalRoot from './ModalRoot';

export default function Modal({ title, onClose, children, wide }) {
  const overlayRef = useRef(null);
  const mouseDownTarget = useRef(null);

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  // Only close if BOTH mousedown AND mouseup happened on the overlay itself
  // This prevents accidental closes when selecting text and dragging outside
  const handleMouseDown = (e) => {
    mouseDownTarget.current = e.target;
  };

  const handleClick = (e) => {
    if (e.target === overlayRef.current && mouseDownTarget.current === overlayRef.current) {
      onClose();
    }
  };

  return (
    <ModalRoot ref={overlayRef} onMouseDown={handleMouseDown} onClick={handleClick}>
      <div className={`modal-content ${wide ? 'modal-wide' : ''}`}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </ModalRoot>
  );
}
